import { FormFieldErrorComponent } from './form-field-error.component';

export default angular
  .module('sfMobile.components.field-error', [
    'sfMobile.services.form',
    'sfMobile.templates',
  ])
  .component('sfFormFieldError', FormFieldErrorComponent).name;
